<mt-card class="mt-card"
		 :title="$tc('postfinancecheckout-settings.settingForm.storefrontOptions.cardTitle')">
	<sw-container>
		<div v-if="actualConfigData" class="postfinancecheckout-settings-storefront-options-fields">
			<sw-inherit-wrapper
					v-model:value="actualConfigData[CONFIG_STOREFRONT_INVOICE_DOWNLOAD_ENABLED]"
					:inheritedValue="selectedSalesChannelId == null ? null : allConfigs['null'][CONFIG_STOREFRONT_INVOICE_DOWNLOAD_ENABLED]"
					:customInheritationCheckFunction="checkBoolFieldInheritance">
				<template #content="props">
					<sw-switch-field
							:name="CONFIG_STOREFRONT_INVOICE_DOWNLOAD_ENABLED"
							bordered
							:mapInheritance="props"
							:label="$tc('postfinancecheckout-settings.settingForm.storefrontOptions.invoiceDownloadEnabled.label')"
							:helpText="$tc('postfinancecheckout-settings.settingForm.storefrontOptions.invoiceDownloadEnabled.tooltipText')"
							:disabled="props.isInherited"
							:value="props.currentValue"
							@update:value="props.updateCurrentValue">
					</sw-switch-field>
				</template>
			</sw-inherit-wrapper>
		</div>
	</sw-container>
</mt-card>

